var React = require('react');

function ProductsIcon28Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_41","data-name":"Obszar roboczy 41","transform":"translate(-5.52 -5.88)"},[React.createElement("rect",{"id":"Rectangle_1086","data-name":"Rectangle 1086","width":"2.75","height":"7.28","transform":"translate(24.78 27.48)","key":0}),React.createElement("path",{"id":"Path_356","data-name":"Path 356","d":"M30.61,15.77h3.02L29.22,5.88H26.15l4.42,9.89H27.54l4.41,9.89h3.07Z","key":1}),React.createElement("path",{"id":"Path_357","data-name":"Path 357","d":"M18.68,15.77H21.7l-4.41,9.89h3.06l4.42-9.89H21.74l4.41-9.89H23.09Z","key":2}),React.createElement("path",{"id":"Path_358","data-name":"Path 358","d":"M8.11,18.55,20.42,5.88H16.81L5.52,17.5V34.76H20.74V32.17H8.11Z","key":3})]));
}

ProductsIcon28Inline.defaultProps = {"width":"29.5","height":"28.88","viewBox":"0 0 29.5 28.88"};

module.exports = ProductsIcon28Inline;

ProductsIcon28Inline.default = ProductsIcon28Inline;
